import React, { memo } from 'react';
import Div from '../Div';
import Images from '../Image';
import Span from '../Span';
import Button from '../Button';
import { getProductURL } from '@/utils/urls';

type RecentViewCardProps = {
  name: string;
  materialId: string;
  slug: string;
  image: string;
};

const RecentViewCard = ({ name, materialId, slug, image }: RecentViewCardProps) => {
  return (
    <Button
      className="whitespace-break-spaces flex-shrink-0 md:flex-shrink !inline-block w-36 md:w-2/6 md:!flex flex-col md:flex-row rounded-2xl bg-cs-primary border !border-cm-subtle overflow-hidden !items-start hover:bg-cs-primary !p-0 !text-left hover:no-underline gap-0"
      theme="link"
      href={getProductURL(materialId ?? '', slug)}
      dataTestId={'RecentViewCard'}
    >
      <Div className="bg-cs-secondary border-b md:border-b-0 md:border-r border-cm-subtle w-full md:w-32 px-s5 py-s3 flex items-center justify-center  md:h-full">
        <Images
          alt={name}
          src={image}
          className="w-full object-contain h-[94px]"
          width={100}
          height={100}
        />
      </Div>
      <Div className="p-s5 text-body-base md:text-body-lg text-cm-primary h-[104px] md:h-auto md:w-[calc(100%-8rem)]">
        <Span className="!line-clamp-3">{name}</Span>
      </Div>
    </Button>
  );
};

export default memo(RecentViewCard);
